<div class="modal-header color-primario-fondo text-white">
    <h4 class="modal-title">
        Éxito
    </h4>
    <button type="button" class="btn btn-primary color-secundario-fondo" aria-label="Close" (click)="onClickDismiss($event,'Modal cerrado')">Cerrar</button>
</div>
<div class="modal-body text-center">
    <i class="bi bi-check-circle-fill icono-exito"></i>
    <h5 class="py-3">{{mensaje}}</h5>
</div>
